import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'glb-glb-components',
  template: `
    <p>
      glb-components works!
    </p>
  `,
  styles: []
})
export class GlbComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
